import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.gray};
  gap: 1px;

  > :first-child {
    color: ${({ theme }) => theme.colors.text};
    font-weight: bold;
  }
`;

export { Container };